import React from 'react';
import TrocaIcone from '../ui/TrocaIcone';
import { Sun, Moon } from 'phosphor-react';

interface SettingsHeaderProps {
  userName: string | null | undefined;
  isDark: boolean;
  onToggleTheme: () => void;
}

export default function SettingsHeader({ userName, isDark, onToggleTheme }: SettingsHeaderProps) {
  return (
    <header className="px-5 pt-12 pb-2">
      <div className="max-w-lg mx-auto flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Meu perfil</h1>
          <p className="text-sm text-nude-400 dark:text-gray-400 mt-1">
            Gerencie suas informações e preferências
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onToggleTheme}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-white dark:bg-gray-800 shadow-soft dark:shadow-none border border-nude-100 dark:border-gray-700 text-nude-400 dark:text-gray-300 hover:text-blush-500 transition-colors"
            aria-label={isDark ? 'Modo claro' : 'Modo escuro'}
          >
            {/* Sol e lua ocupam a mesma caixa. Trocar o tema é raro, e a troca do
                ícone é a única confirmação visual de que o toque pegou. */}
            <TrocaIcone
              ativo={isDark}
              quandoAtivo={<Sun className="w-4 h-4" />}
              quandoInativo={<Moon className="w-4 h-4" />}
            />
          </button>
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-blush-100 dark:bg-gray-800 border border-nude-100 dark:border-gray-700 text-blush-600 dark:text-gray-200 text-sm font-bold">
            {userName?.charAt(0).toUpperCase() || '?'}
          </div>
        </div>
      </div>
    </header>
  );
}
